export class BulkUpload {
  BulkUploadID: number;
  UploadTypeID: number;
  Description: string;
  DescriptionIsValid: boolean;
  IsComplete: boolean;
}
